import {
  FormButtonBelowContent,
  FormContent,
  FormContentBody,
  FormContentHeadings,
  InputBox,
  InputBoxContainer,
  InputBoxInsideContainer,
  QuestionSubtext,
} from 'src/consumer/components/Form/FormStyles'
import { ADDICTION_TYPES_OPTIONS } from '../../utils'
import { FrequencySelectionHeading } from '../FrequencySelection/styledComponents'

export default function GoalSelection({ formData, setFormData, goToNextPage }) {
  function checkDisabled() {
    if (!!formData?.goal) {
      if (Number(formData?.goal) >= Number(formData?.frequency)) {
        return true
      }
      return false
    }
    return true
  }

  function setAddictionGoalFrequency(value) {
    setFormData((prev) => {
      return {
        ...prev,
        goal: value,
      }
    })
  }

  return (
    <>
      <FormContent>
        <FormContentHeadings>
          <FrequencySelectionHeading>
            I wish to reduce my current frequency - {formData?.frequency} times per{' '}
            {formData?.frequencyRate} of{' '}
            {
              ADDICTION_TYPES_OPTIONS?.find(
                (addType) => addType?.value === formData?.addictionTypes?.[0],
              )?.title
            }{' '}
            to
          </FrequencySelectionHeading>
          <QuestionSubtext>
            We respect your privacy, we just need some info to create the right plan for you.
          </QuestionSubtext>
        </FormContentHeadings>
        <FormContentBody>
          <InputBoxContainer style={{ margin: '5px 0' }}>
            <InputBoxInsideContainer>
              <InputBox
                type="number"
                value={formData?.goal}
                placeholder="Goal"
                onChange={(e) => setAddictionGoalFrequency(e.target.value)}
              />
            </InputBoxInsideContainer>
          </InputBoxContainer>
          {Number(formData?.goal) >= Number(formData?.frequency) ? (
            <span style={{ fontWeight: '600', color: '#584dee' }}>
              It is better to aim to reduce the frequency of your addictions for a healthier life.
            </span>
          ) : (
            <span style={{ color: 'transparent', fontWeight: '600' }}>placeholder</span>
          )}
        </FormContentBody>
      </FormContent>
      <FormButtonBelowContent onClick={goToNextPage} disabled={checkDisabled()}>
        Continue
      </FormButtonBelowContent>
    </>
  )
}
